import { AxiosResponse } from 'axios';
import { IFeesAndTaxesFormOptions, IProbabilityEstimatorPreferencesFormOptions } from 'modules/core/types';
import { convertFalsyValuesToZero } from 'modules/core/utils';
import { ProbabilityEstimatorService } from 'modules/ProbabilityEstimator/services/probabilityEstimator.service';

import { ILenderForm, IShopByCallbackForm } from '../types/Lender.types';

export class LenderService {
  static hasLoanTerms(response?: AxiosResponse<unknown> | null): boolean {
    const loanTerms = response?.data;

    return Array.isArray(loanTerms) && loanTerms.length > 0;
  }

  static getSubmitQuery(formValues: ILenderForm): Record<string, unknown> {
    const {
      feesAndTaxes,
      tier,
      preferences,
      totalNetDownPaymentDialog,
      totalFrontAndBackEndsAddsDialog,
      vehicleFilters,
      tableView,
      shopByCallback,
      ...restValues
    } = formValues;
    const { salesTaxRate, ...restFeesAndTaxes } = feesAndTaxes;

    const sbcFields = LenderService.getShopByCallbackFields(shopByCallback);

    return {
      ...restValues,
      ...tier,
      ...ProbabilityEstimatorService.getFilterObject(vehicleFilters, tableView),
      ...convertFalsyValuesToZero(restFeesAndTaxes as Record<IFeesAndTaxesFormOptions, number>),
      ...convertFalsyValuesToZero(preferences as Record<IProbabilityEstimatorPreferencesFormOptions, string | number>),
      ...totalFrontAndBackEndsAddsDialog,
      amountOwed: totalNetDownPaymentDialog.amountOwed || 0,
      tradeValue: totalNetDownPaymentDialog.tradeValue || 0,
      cashDown: totalNetDownPaymentDialog.cashDown || 0,
      tableView,
      salesTaxRate,
      ...sbcFields,
    };
  }

  static getShopByCallbackFields(shopByCallback?: IShopByCallbackForm): Record<string, unknown> {
    if (!shopByCallback) {
      return {};
    }

    const result: Record<string, unknown> = {};

    if (shopByCallback.sbcTerm?.value) {
      result.loan_term = shopByCallback.sbcTerm.value;
    }

    if (shopByCallback.sbcApr !== null && shopByCallback.sbcApr !== undefined && shopByCallback.sbcApr >= 0) {
      result.apr = shopByCallback.sbcApr;
    }

    if (shopByCallback.sbcLtv !== null && shopByCallback.sbcLtv !== undefined && shopByCallback.sbcLtv > 0) {
      result.ltv_high_limit = shopByCallback.sbcLtv;
    }

    return result;
  }
}
